import { gql } from "@apollo/client";

export const TUTOR_AWARD_CERTIFICATE_FIELDS = gql`
  fragment TutorAwardCertificateFields on TutorAwardCertificate {
    id
    firstname
    lastname
    year
    date
    place
    text
    president
    # president {
    #   id
    #   email
    #   firstname
    #   lastname
    #   type
    # }
    author {
      id
      name
      type
    }
    college {
      id
      name
      title
      status
      certified
      logo {
        id
        title
        filename
        filesize
        filetype
        url
      }
    }
    done
    created_at
    updated_at
    uid {
      id
      code
      created_at
    }
  }
`;

export const GET_TUTOR_AWARD_CERTIFICATE = gql`
  query TutorAwardCertificate($id: ID!) {
    certTutorAwardCertificate(id: $id) {
      ...TutorAwardCertificateFields
    }
  }
  ${TUTOR_AWARD_CERTIFICATE_FIELDS}
`;

export const GET_TUTOR_AWARD_CERTIFICATES = gql`
  query TutorAwardCertificates(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetTutorAwardCertificatesOrderByClause]
  ) {
    certTutorAwardCertificates(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...TutorAwardCertificateFields
      }
    }
  }
  ${TUTOR_AWARD_CERTIFICATE_FIELDS}
`;
